/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import { IncDecField } from '@insticator/insticator-ui'
// styles
import injectSheet from 'react-jss'
import styles from './placements_styles'
import Space from 'material/space/space';
import ToggleButton from 'material/togglebutton/togglebutton';

const Reply = ({ type = 'reply', children, version }) => {
  return (
    <Space direction={'column'}>
      <Space alignItems={'center'}>
        <div className='placeholder rounded'>
          {type === 'reply' ? 'R' : 'N'}
        </div>
        <div className='placeholder' style={{width: '88px'}} />
      </Space>
      <Space direction={'column'} style={children ? {marginLeft: '8px', paddingLeft: '24px', borderLeft: '1px solid #EEEFF1'}: {paddingLeft: '24px'}}>
        <div className='placeholder' style={{width: version === 'desktop' ? '246px' : '216px'}} />
        <div className='placeholder' style={{width: version === 'desktop' ? '200px' : '180px'}} />
        {children}
      </Space>
    </Space>
  )
}
/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : MEDIA COMMENTS ~~~~~~~~~~ ========== */
const Placements = injectSheet(styles)((props) => {

  const {  
    showAdsBeforeCommentingUnit,
    showAdsAfterFirstComment,
    showAdsBetweenRootComments,
    adsCountBetweenRootComments,
    showAdsBetweenReplies,
    adsCountBetweenReplies,
    showAdsAfterLoadMoreButton,
    showAdsAfterCommentingUnit, 
    version, 
    selectVersion, 
    visibility,
    onChange 
  } = props

  const placementVersion = [
    {label: 'Desktop', value: 'desktop'},
    {label: 'Mobile', value: 'mobile'}
  ]

  return (
    <Space justifyContent={'space-between'} klass={`placements ${props.classes.placements}`} >
    <SectionGroupV2 
      title={'Placements'} 
      description={'Enable where each ad space can display within the commenting unit'}
      indented  
      disabled={visibility === 'NONE'}
    >
      <Space gap={16} direction={'column'}>
      <ToggleButton selected={version} items={placementVersion} onChange={item => selectVersion(item.value)} />
      <Space gap={16} direction={'column'} klass={visibility === 'NONE' ? 'disabled' : ''}>
      <ConfigToggle 
        title={'Before commenting unit'}
        checked={showAdsBeforeCommentingUnit}
        onChange={val => onChange('showAdsBeforeCommentingUnit', val)}
      />
      <ConfigToggle 
        title={'After first comment'}
        checked={showAdsAfterFirstComment}
        onChange={val => onChange('showAdsAfterFirstComment', val)}
        gap={16}
      />
      <ConfigToggle 
        title={'In-between root comments'}
        checked={showAdsBetweenRootComments}
        onChange={val => onChange('showAdsBetweenRootComments', val)}
        gap={16}
      >
         <IncDecField
          name={'inbetweenrootcommentscount'}
          defaultValue={adsCountBetweenRootComments}
          minValue={1}
          maxValue={25}
          handleIncToggle={val => onChange('adsCountBetweenRootComments', val)}
          handleDecToggle={val => onChange('adsCountBetweenRootComments', val)}
          ctaPosition={'inline'}
          disabled={!showAdsBetweenRootComments}
        />
      </ConfigToggle>
      <ConfigToggle 
        title={'In-between nested replies'}
        checked={showAdsBetweenReplies}
        onChange={val => onChange('showAdsBetweenReplies', val)}
        gap={16}
      >
        <IncDecField
          name={'inbetweennestedrepliescount'}
          defaultValue={adsCountBetweenReplies}
          minValue={1}
          maxValue={25}
          handleIncToggle={val => onChange('adsCountBetweenReplies', val)}
          handleDecToggle={val => onChange('adsCountBetweenReplies', val)}
          ctaPosition={'inline'}
          disabled={!showAdsBetweenReplies}
        />
      </ConfigToggle>
      <ConfigToggle 
        title={'After user selects "Load More Comments" button'}
        checked={showAdsAfterLoadMoreButton}
        onChange={val => onChange('showAdsAfterLoadMoreButton', val)}
        gap={16}
      />
      <ConfigToggle 
        title={'After commenting unit'}
        checked={showAdsAfterCommentingUnit}
        onChange={val => onChange('showAdsAfterCommentingUnit', val)}
        gap={16}
      />
      </Space>
      </Space>
    </SectionGroupV2>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Placements;